/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Import_Hls_LabelInputs */

const en_media_import_hls_label = /** @type {(inputs: Media_Import_Hls_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HLS Manifest URL`)
};

const fr_media_import_hls_label = /** @type {(inputs: Media_Import_Hls_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL du manifeste HLS`)
};

const de_media_import_hls_label = /** @type {(inputs: Media_Import_Hls_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HLS-Manifest-URL`)
};

const it_media_import_hls_label = /** @type {(inputs: Media_Import_Hls_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL manifesto HLS`)
};

const ru_media_import_hls_label = /** @type {(inputs: Media_Import_Hls_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL манифеста HLS`)
};

const es_media_import_hls_label = /** @type {(inputs: Media_Import_Hls_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL del manifiesto HLS`)
};

const zh_cn2_media_import_hls_label = /** @type {(inputs: Media_Import_Hls_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HLS清单URL`)
};

const ja_media_import_hls_label = /** @type {(inputs: Media_Import_Hls_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HLSマニフェストURL`)
};

const hi_media_import_hls_label = /** @type {(inputs: Media_Import_Hls_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HLS मैनिफेस्ट URL`)
};

const pt_pt2_media_import_hls_label = /** @type {(inputs: Media_Import_Hls_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL do manifesto HLS`)
};

/**
* | output |
* | --- |
* | "HLS Manifest URL" |
*
* @param {Media_Import_Hls_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const media_import_hls_label = /** @type {((inputs?: Media_Import_Hls_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Import_Hls_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_media_import_hls_label(inputs)
	if (locale === "de") return de_media_import_hls_label(inputs)
	if (locale === "it") return it_media_import_hls_label(inputs)
	if (locale === "ru") return ru_media_import_hls_label(inputs)
	if (locale === "es") return es_media_import_hls_label(inputs)
	if (locale === "zh-CN") return zh_cn2_media_import_hls_label(inputs)
	if (locale === "ja") return ja_media_import_hls_label(inputs)
	if (locale === "hi") return hi_media_import_hls_label(inputs)
	if (locale === "pt-PT") return pt_pt2_media_import_hls_label(inputs)
	return en_media_import_hls_label(inputs)
});